<template>
  <div>
    <h3>Shortage Area Category</h3>
    <teacher-bonus-table :fiscal-year="fiscalYear" :lea="selectedLea.number" category="ShortageArea" />
  </div>
</template>

<script>
import TeacherBonusTable from './tables/TeacherBonusTable.vue'
import { mapState } from 'vuex'

export default {
  components: { TeacherBonusTable },
  computed: {
    ...mapState('tgsModule', ['fiscalYear']),
    selectedLea() {
      return this.$store.state.globalModule.leaContext.SelectedLea
    }
  }
}
</script>
